import React from 'react'
import { Badge } from 'reactstrap'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import StatusFailedIcon from '../svgs/StatusFailedIcon'
import StatusPendingIcon from '../svgs/StatusPendingIcon'
import StatusRunningIcon from '../svgs/StatusRunningIcon'
import StatusSuccessIcon from '../svgs/StatusSuccessIcon'

const IntegrationBadge = ({ state }) => {
  const { t } = useTranslation('IntegrationBadge')

  const badgeColorFromState = () => {
    if (state === 'pending') return 'warning'
    if (state.endsWith('ing')) return 'primary'
    if (state.endsWith('_succeeded')) return 'success'
    if (state.endsWith('_failed')) return 'danger'

    return 'warning'
  }

  const badgeIconFromState = () => {
    if (state === 'pending') return <StatusPendingIcon />
    if (state === 'fetching_succeeded') return <StatusSuccessIcon />
    if (state.endsWith('ing')) return <StatusRunningIcon />
    if (state.endsWith('_succeeded')) return <StatusRunningIcon />
    if (state.endsWith('_failed')) return <StatusFailedIcon />

    return <StatusPendingIcon />
  }

  return (
    <Badge
      className="d-flex align-items-center px-2 py-1"
      color={badgeColorFromState()}
    >
      {badgeIconFromState()}
      &nbsp;
      {t(state)}
    </Badge>
  )
}

IntegrationBadge.propTypes = {
  state: PropTypes.string.isRequired
}

export default IntegrationBadge
